import { useMemo } from "react";
import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useEditions from "./useEditions";

export default function useCharts( params ) {
   const { d: editions } = useEditions();
   
   // Znajdź edition_id na podstawie edition name
   const edition_id = useMemo(() => {
      if (!params?.edition || !editions) return null;
      const edition = editions.find(e => e.value === params.edition);
      return edition?.id || null;
   }, [params?.edition, editions]);
   
   return useFetchData({
      APIMethod: API.getCharts,
      clear_data_on_update: true,
      debounce: true,
      // W trybie porównania nie wywołujemy tego endpointu
      condition: !!params?.key_variable_id && !!edition_id && params?.compare_mode !== "compare",
      params: [{
         edition_id: edition_id,
         key_variable_id: params.key_variable_id,
         grouping_variable_ids: params.grouping_variable_ids,
         filters: params.filters
      }]
   })
}